<sb-card [loading]=loading>
  <div card-header>
    <div class="d-flex flex-row">
      <div class="mr-2"><b>{{'lang.globals.overview' | translate}}</b></div>
    </div>
  </div>
  <div card-body>
    <div class="row">
      <div class="col-xxl-6 col-xl-8 col-lg-8 col-md-12">
        <ng-container *ngIf="tracker">
          <div class="flex-grow-1 w-100">
            <div class="mt-4">
              <h5 class="mb-2">{{'lang.globals.data' | translate}}</h5>
              <div class="d-flex justify-content-between align-items-center mb-1">
                <span class="text-dark-75 font-weight-bolder">
                  {{'lang.globals.identifier' | translate}}:
                </span>
                <span class="text-muted">
                  <ng-container *ngIf="tracker.identifier">
                    {{tracker.identifier}}
                  </ng-container>
                  <i *ngIf="!tracker.identifier">
                    <a>&#91;{{'lang.deviceDetails.nDef' | translate}}.&#093;</a>
                  </i>
                </span>
              </div>
              <div class="d-flex justify-content-between align-items-center mb-1">
                <span class="text-dark-75 font-weight-bolder">
                  {{'lang.globals.timezone' | translate}}:
                </span>
                <span class="text-muted">
                  <ng-container *ngIf="tracker.timezone">
                    {{tracker.timezone}}
                  </ng-container>
                  <i *ngIf="!tracker.timezone">
                    <a>&#91;{{'lang.deviceDetails.nDef' | translate}}.&#093;</a>
                  </i>
                </span>
              </div>

              <div class="d-flex justify-content-between align-items-center mb-1">
                <span class="text-dark-75 font-weight-bolder">
                  {{'lang.globals.location' | translate}}:
                </span>
                <span class="text-muted">
                  <ng-container *ngIf="tracker.location">
                    <ng-container
                      *ngIf="permissionService.hasPermission(permissionService.Permission.location_show); else locationNoShowPermission">
                      <a
                        [sbRouterLink]="util.RoutingID.locationDetails"
                        [pathParams]="[{id: 'locationID', value: tracker?.location?.id}]">
                        {{tracker.location.name}}
                      </a>
                    </ng-container>
                    <ng-template #locationNoShowPermission>
                      <a>
                        {{tracker.location.name}}
                      </a>
                    </ng-template>
                  </ng-container>
                  <i *ngIf="!tracker.location">
                    <a>&#91;{{'lang.deviceDetails.nDef' | translate}}.&#093;</a>
                  </i>
                </span>
              </div>

              <div class="d-flex justify-content-between align-items-center mb-1">
                <span class="text-dark-75 font-weight-bolder">
                  {{'lang.globals.technique' | translate}}:
                </span>
                <span class="text-muted">
                  <sb-icon icon="{{util.getTrackerIcon(tracker)}}"></sb-icon>
                  &nbsp;{{tracker.technique}}
                </span>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
      <div class="col-xxl-2 col-xl-4 col-lg-4 col-md-12">
        <ng-container *ngIf="tracker">
          <div class="flex-grow-1 w-100">
            <div class="mt-4">
              <sb-comp-tracker-status [tracker]="tracker"></sb-comp-tracker-status>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</sb-card>
